import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../../packages/api-models/common/json_query';

export interface IBannerTrackingParams {
  bannerId: string;
  name: string;
  position?: number;
  isShortListing?: boolean;
  jsonQuery: IJsonQuery;
}

export function trackBannerEvent({ bannerId, position, name, jsonQuery, isShortListing }: IBannerTrackingParams) {
  const page = typeof isShortListing === 'undefined' ? undefined : { extra: { is_short: isShortListing } };

  ca('teaser', {
    product: {
      id: Number(bannerId),
      offerType: 'TGB_banner',
      name,
      position,
    },
    page,
    sc: jsonQuery,
  });
}
